<template>
  <div id="featured-vehicles-component" :data-brand="brand.substr(0,1).toLowerCase() + brand.substr(1)">
    <div class="featured-car-bg">
      <div class="container">
        <div class="row">
          <div class="col-sm-8 col-sm-offset-2 col-xs-12 featured-car-border">
            <h2 class="text-center">Your Featured Vehicles</h2>
          </div>
        </div>
        <div class="row flex-row">
          <div class="col-sm-3 col-xs-6 featured-vehicle-block">
            <div class="wrapper">
              <div class="featured-car-img">
                <a href="#">
                  <img :alt="brandName" :src="vehicleOne.angleView">
                </a>
              </div>
              <div class="featured-car-data">
                <div class="spects">
                  <div class="feat-year">2023</div>
                  <div class="feat-model">{{vehicleOne.modelName}}</div>
                  <div class="feat-mileage">Mileage: <span>20</span></div>
                  <div class="feat-color--ext">Exterior Color: <span>Wolf Gray</span></div>
                  <a alt="Learn More" class="toggle-eprice-modal eprice-button" :class="[brand === 'toyota' || brand === 'nissan' ? 'secondary-btn' : 'primary-btn', brandName.toLowerCase() + '-btn']" href="#">Learn More</a>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-3 col-xs-6 featured-vehicle-block">
            <div class="wrapper">
              <div class="featured-car-img">
                <a href="#">
                  <img :alt="brandName" :src="vehicleTwo.angleView">
                </a>
              </div>
              <div class="featured-car-data">
                <div class="spects">
                  <div class="feat-year">2021</div>
                  <div class="feat-model">{{vehicleTwo.modelName}}</div>
                  <div class="feat-mileage">Mileage: <span>34,560</span></div>
                  <div class="feat-color--ext">Exterior Color: <span>Wolf Gray</span></div>
                  <a alt="Learn More" class="toggle-eprice-modal eprice-button" :class="[brand === 'toyota' || brand === 'nissan' ? 'secondary-btn' : 'primary-btn', brandName.toLowerCase() + '-btn']" href="#">Learn More</a>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-3 col-xs-6 featured-vehicle-block">
            <div class="wrapper">
              <div class="featured-car-img">
                <a href="#">
                  <img :alt="brandName" :src="vehicleThree.angleView">
                </a>
              </div>
              <div class="featured-car-data">
                <div class="spects">
                  <div class="feat-year">2022</div>
                  <div class="feat-model">{{vehicleThree.modelName}}</div>
                  <div class="feat-mileage">Mileage: <span>11,879</span></div>
                  <div class="feat-color--ext">Exterior Color: <span>Wolf Gray</span></div>
                  <a alt="Learn More" class="toggle-eprice-modal eprice-button" :class="[brand === 'toyota' || brand === 'nissan' ? 'secondary-btn' : 'primary-btn', brandName.toLowerCase() + '-btn']" href="#">Learn More</a>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-3 col-xs-6 featured-vehicle-block">
            <div class="wrapper">
              <div class="featured-car-img">
                <a href="#">
                  <img :alt="brandName" :src="vehicleFour.angleView">
                </a>
              </div>
              <div class="featured-car-data">
                <div class="spects">
                  <div class="feat-year">2023</div>
                  <div class="feat-model">{{vehicleFour.modelName}}</div>
                  <div class="feat-mileage">Mileage: <span>10</span></div>
                  <div class="feat-color--ext">Exterior Color: <span>Wolf Gray</span></div>
                  <a alt="Learn More" class="toggle-eprice-modal eprice-button" :class="[brand === 'toyota' || brand === 'nissan' ? 'secondary-btn' : 'primary-btn', brandName.toLowerCase() + '-btn']" href="#">Learn More</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['images'],
  data() {
    return {
      brand: this.$store.state.chosenBrand,
      activeClass: 'active'
    }
  },
  computed: {
    brandName () {
      if (this.brand === 'none') {
        return 'default';
      } else if (this.brand === 'infiniti' || this.brand === 'cjdr') {
        return this.brand.toUpperCase();
      } else {
        return this.brand.charAt(0).toUpperCase() + this.brand.slice(1);
      }
    },
    vehicleOne () {
      if (this.images.sedans.length > 0) {
        return this.images.sedans[0];
      } else {
        return this.images.suvs[0];
      }
    },
    vehicleTwo () {
      if (this.images.sedans.length > 0) {
        return this.images.suvs[0];
      } else {
        return this.images.suvs[1];
      }
    },
    vehicleThree () {
      if (this.images.sedans.length > 0) {
        return this.images.suvs[1];
      } else {
        return this.images.suvs[2];
      }
    },
    vehicleFour () {
      if (this.images.trucks.length > 0) {
        return this.images.trucks[0];
      } else if (this.images.sedans.length > 0) {
        return this.images.suvs[2];
      } else {
        return this.images.suvs[3];
      }
    },
  }
};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
#featured-vehicles-component {
  background: #fff;
  font-family: Helvetica, Arial, sans-serif;
}
  #featured-vehicles-component .featured-car-border h2 {
    margin: 30px auto;
  }
  #featured-vehicles-component .flex-row {
    display: flex;
    flex-wrap: wrap;
  }
  #featured-vehicles-component .featured-vehicle-block .wrapper {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    padding: 10px;
    -webkit-box-shadow: 0px 0px 15px 7px rgba(118,118,118,0);
    box-shadow: 0px 0px 15px 7px rgba(118,118,118,0);
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transition: all .3s ease;
  }
  #featured-vehicles-component .featured-vehicle-block .wrapper:hover {
    transform: scale(1.05);
    -webkit-box-shadow: 0px 0px 15px 7px rgba(118,118,118,.15);
    box-shadow: 0px 0px 15px 7px rgba(118,118,118,.15);
  }
  #featured-vehicles-component .featured-vehicle-block .eprice-button {
    width: 100%;
    text-align: center;
    display: inline-block;
    margin-top: 5px;
    font-size: 16px;
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transition: all .3s ease;
  }
  #featured-vehicles-component .featured-car-img {
    padding-top: 20px;
    text-align: center;
    display: flex;
    align-items: center;
    height: 100%;
  }
  #featured-vehicles-component .featured-car-img img {
    max-width: 100%;
    max-height: 200px;
    margin: auto;
    display: block;
  }
  #featured-vehicles-component .featured-car-data {
    transition: padding 0.2s ease;
    padding: 0 !important;
    height: auto !important;
    margin-top: auto;
  }
  #featured-vehicles-component .FeaturedHeading {
  width: 100%;
  float: left;
  color: #002571;
  font-size: 16px;
  line-height: 16px;
  font-weight: 600;
  }
  #featured-vehicles-component .featured-vehicle-vin {
  color: #002571;
  }
  #featured-vehicles-component .FeaturedPriceTag {
  width: 100%;
  color: #002571;
  float: left;
  font-size: 14px;
  margin: 5px 0px 0px 0px;
  font-weight: 600;
  }
  #featured-vehicles-component .spects {
    color: var(--primary-dark);
  }
  #featured-vehicles-component .spects > * {
    margin: 10px 0px;
  }
  #featured-vehicles-component .feat-year {
    font-size: 16px;
    align-self: end;
  }
  #featured-vehicles-component .feat-model {
    font-size: 16px;
    background-color:var(--primary-dark);
    color: #ffffff;
    width: fit-content;
    padding: 0 10px;
    align-self: center;
  }
  #featured-vehicles-component .feat-color--ext {
    padding-top: 10px;
    align-self: center;
    border-top: solid 1px #999999;
    margin-bottom: 15px;
  }
  #featured-vehicles-component .feat-mileage, #featured-vehicles-component .feat-color--ext {
    font-size: 13px;
    font-weight: bold;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  @media only screen and (min-width: 900px) and (max-width: 1100px) {
    #featured-vehicles-component .FeaturedHeading {
    font-size: 14px;
    line-height: 14px;
    }
  }

@media only screen and (min-width: 768px) and (max-width: 900px) {
  #featured-vehicles-component .FeaturedHeading {
    font-size: 13px;
    line-height: 13px;
  }
}

@media only screen and (min-width: 150px) and (max-width: 768px) {
  #featured-vehicles-component .FeaturedHeading {
    width: 100%;
    float: left;
    color: #002571;
    font-size: 16px;
    line-height: 16px;
  }
}

#featured-vehicles-component .dealer-featured-image {
  max-width: 100%;
  margin-top: 15px;
}
  #featured-vehicles-component .featured-car-bg {
  width: 100%;
  background-color: #FFF;
  padding: 0px 0px 20px 0px;
}

@media (max-width: 991px) {
  #featured-vehicles-component .featured-vehicle-block .eprice-button {
    font-size: 14px;
    padding-left: 0px;
    padding-right: 0px;
  }
}

@media (max-width: 767px) {
  #featured-vehicles-component .featured-vehicle-block .flex-row .col-xs-6 {
    padding-bottom: 30px;
  }
}

#featured-vehicles-component .ribbon-wrapper-green {
  width: 85px;
  height: 88px;
  overflow: hidden;
  position: absolute;
  top: -3px;
  right: -3px;
}
#featured-vehicles-component .ribbon-green {
  font: bold 15px Sans-Serif;
  color: #000;
  text-align: center;
  text-shadow: rgba(255, 255, 255, 0.5) 0px 1px 0px;
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  transform: rotate(45deg);
  position: relative;
  z-index: 2;
  padding: 7px 0;
  left: -5px;
  top: 15px;
  width: 120px;
  background-color: #f58b05;
  background-image: -webkit-gradient(linear, left top, left bottom, from(#f58b05), to(#F5BF05));
  background-image: -webkit-linear-gradient(top, #f58b05, #F5BF05);
  background-image: -moz-linear-gradient(top, #f58b05, #F5BF05);
  background-image: -ms-linear-gradient(top, #f58b05, #F5BF05);
  background-image: -o-linear-gradient(top, #f58b05, #F5BF05);
  color: #000;
  -webkit-box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.3);
  -moz-box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.3);
  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.3);
}
#featured-vehicles-component .ribbon-green:before, #featured-vehicles-component .ribbon-green:after {
  content: "";
  border-top: 3px solid #6e8900;
  border-left: 3px solid transparent;
  border-right: 3px solid transparent;
  position: absolute;
  bottom: -3px;
}
#featured-vehicles-component .ribbon-green:before {
  left: 0;
}
#featured-vehicles-component .ribbon-green:after {
  right: 0;
}

/* brand specific */
#featured-vehicles-component[data-brand="ford"] .feat-model,
#featured-vehicles-component[data-brand="hyundai"] .feat-model {
  background-color: var(--primary-color);
}
#featured-vehicles-component[data-brand="honda"] .feat-model,
#featured-vehicles-component[data-brand="mitsubishi"] .feat-model,
#featured-vehicles-component[data-brand="nissan"] .feat-model,
#featured-vehicles-component[data-brand="toyota"] .feat-model {
  color: var(--primary-color);
  background-color: transparent;
  padding: 0;
  font-family: var(--bold-text);
  font-weight: 600;
}
#featured-vehicles-component[data-brand="toyota"] .eprice-button {
  background: var(--primary-dark);
  color: var(--primary-light);
}
#featured-vehicles-component[data-brand="toyota"] .eprice-button:hover {
  background: var(--primary-light);
  color: var(--primary-dark);
}
#featured-vehicles-component[data-brand="cjdr"] .eprice-button {
  background-color: var(--primary-dark);
}
</style>